import { ChatEnabledFilterValues } from '@choco-admin/types';

/**
 * Maps enabled filter values to boolean for GraphQL queries
 */
export const mapEnabledFilterToBoolean = (
  enabledState: ChatEnabledFilterValues
): boolean | undefined => {
  switch (enabledState) {
    case 'enabled':
      return true;
    case 'disabled':
      return false;
    case 'all':
    default:
      return undefined;
  }
};

/**
 * Type guard to check if a string is a valid enabled filter value
 */
export const isValidEnabledFilterValue = (
  value: string
): value is ChatEnabledFilterValues => {
  return ['all', 'enabled', 'disabled'].includes(value);
};
